import { render } from "./AccountTypeUpdate.vue?vue&type=template&id=b131ab66&scoped=true"
import script from "./AccountTypeUpdate.vue?vue&type=script&lang=js"
export * from "./AccountTypeUpdate.vue?vue&type=script&lang=js"

import "./AccountTypeUpdate.vue?vue&type=style&index=0&id=b131ab66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b131ab66"]])

export default __exports__